import { CREATE_LOCATION_CONTACT_SUCCESS, DELETE_LOCATION_CONTACT_SUCCESS, DELETE_LOCATION_IMAGE_SUCCESS, PATCH_LOCATION_IMAGES_SUCCESS, REMOVE_GEOPOINT_SUCCESS, REMOVE_LOCATION_FILE_SUCCESS, SAVE_LOCATION_FILE_SUCCESS, SAVE_LOCATION_IMAGE_SUCCESS, SAVE_LOCATION_SUCCESS, SET_LOCATION_STATE_SUCCESS, UPDATE_LOCATION_CONTACT_SUCCESS } from '../../../../shared/components/Locations/Locations.actions';
import { createLogicWithApi } from '../../../../shared/logicCreators';
import { locations as locationsApiConfig, } from '../../../config/api';
import { SAVE_SETTINGS_SUCCESS } from '../../pages/Settings/Settings.actions';
import { CANCEL_CONFIRM_LOCATION, CONFIRM_LOCATION, confirmLocationError, confirmLocationSuccess } from './LocationExpiry.actions';

const confirmLocationLogic = createLogicWithApi({
  type: [
    CONFIRM_LOCATION,
    SAVE_LOCATION_SUCCESS, 
    SAVE_SETTINGS_SUCCESS, 
    SAVE_LOCATION_IMAGE_SUCCESS, 
    DELETE_LOCATION_IMAGE_SUCCESS,
    PATCH_LOCATION_IMAGES_SUCCESS,
    SET_LOCATION_STATE_SUCCESS,
    CREATE_LOCATION_CONTACT_SUCCESS,
    DELETE_LOCATION_CONTACT_SUCCESS,
    UPDATE_LOCATION_CONTACT_SUCCESS,
    SAVE_LOCATION_FILE_SUCCESS,
    REMOVE_LOCATION_FILE_SUCCESS,
    REMOVE_GEOPOINT_SUCCESS,
  ],
  cancelType: CANCEL_CONFIRM_LOCATION,
  process: ({ action, Api }, dispatch, done) => {
    const locationId = 
      action.locationId 
      || ((typeof action.location === 'string' || typeof action.location === 'number') 
          ? action.location 
          : undefined)
      || action.payload?.data?.id 
      || action.id

    if (!locationId) {
      return;
    }

    return Api({
      method: 'PATCH',
      path: `${locationsApiConfig.path}/${locationId}/confirm`
    })
    .then((res) => {
      dispatch(confirmLocationSuccess(res.data));
      done();
    })
    .catch(() => {
      dispatch(confirmLocationError(locationId));
      done();
    });
  }
});

const logics = [
  confirmLocationLogic
];

export default logics;
